import * as XLSX from 'xlsx';

/**
 * 
 * @param {*} file excel文件
 * @param {*} type 传type 说明是地方上传的 需要验证表头 传null不验证
 * @param {boolean} cutSubHead 需要忽略表头第二行的副标
 * @returns 
 */
function excel2Json(file, type, isFinance, cutSubHead) {
    return new Promise((resolve, reject) => {
        try {
            var reader = new FileReader();
            // console.log("start*:" + getTimeStr());
            //文件读取成功完成时触发
            reader.onload = function (e) {
                // console.log("---reader onload----" + getTimeStr());
                var data = e.target.result;
                var workbook = XLSX.read(data, {
                    type: 'binary',
                    raw: true,  // 保留原始字符串不进行类型转换
                    cellText: true,  // 强制以文本形式读取
                    cellDates: true  // 正确处理日期格式
                });
                // console.log("workbook:", workbook);
                // console.log("workbook.Strings:", workbook.Strings);

                //表头有两种，先只验证地方上传的
                // if (type) {

                // }

                // var sheet1 = workbook.Sheets('Sheet1');
                // console.log("sheet1:",sheet1);
                callback(workbook, resolve, type, isFinance, cutSubHead);
            };
            // console.log("readAsBinaryString*:" + getTimeStr());
            // console.log("file:", file);
            // if (!file) {
            //     reject('文件不存在');
            // }
            // console.log('file:', file, typeof file);
            // if (!file) {
            //     resolve([]);
            // }
            var bin = reader.readAsBinaryString(file);
            // console.log('bin:', bin);

            // console.log("-----end:" + getTimeStr());
        } catch (error) {
            reject(error);
        }
    });

}

function excel2JsonCutSubHead(file, type, isFinance) {
    return excel2Json(file, type, isFinance, true)
}

function callback(wb, resolve, type, isFinance, cutSubHead) {
    // console.log('workbook ***:' + getTimeStr(), wb.Workbook);
    let jsono = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { defval: '' });
    // console.log("------------------")
    // console.log('jsono:', jsono);
    // console.log('keys*:', Object.keys(jsono[0]));
    // console.log('callback end:' + getTimeStr());
    // console.log('json1:', jsono[0]);
    // return jsono;
    //验证表头是否正确 type:需要验证  
    if (cutSubHead) {
        jsono.splice(0, 1);
    }
    if (type) {
        let tKeys = null;
        if (jsono && jsono.length) {
            tKeys = Object.keys(jsono[0])
        }
        // @INDEX
        let title = [
            '序号',
            '开立票据名称',
            '身份证号',
            '纳税人识别号',
            '金额',
            '用途',
            '备注',
            // @tmpmdel
            // '非陆籍填1',
            // '法人填1，自然人不填',
            '志工编号',
            '志工姓名',
            '志工英文名',
            '手机号',
            '地址',
            '邮箱']
        //不一致则返回提示
        // @tmptodo 表头长度
        if (tKeys) {
            for (let i = 0; i < 13; i++) {
                if (tKeys[i] != title[i]) {
                    // console.log(workbook.Strings[i].t, title[i]);
                    resolve({
                        title: `表头格式与模板栏位不对应，请使用标准模板处理\n第${i + 1}列应是${title[i]}`,
                    });
                }
            }
            let extra = tKeys.slice(13);
            if (isFinance && extra.length) {
                for (let i = 0; i < extra.length; i++) {
                    let t = extra[i];
                    if (t && t != '项目备注') {
                        console.log('***t:', t, typeof t);
                        let title = `表头格式不对，第${13 + i}列应为“项目备注”,实际为“${t}”`;
                        if (/__EMPTY/.test(t)) {
                            title += '\n(该列有隐藏空白字符，若是空白，请删除【末尾所有可疑空白列】再上传)'
                            title += '\n若仍无效1.请查看是否表头使用了“合并单元格”\n2.使用最新模板重新粘贴'
                        };
                        title += ''
                        resolve({
                            title
                        });
                    }
                }
            }
        } else {
            for (let i = 0; i < 13; i++) {
                if (wb.Strings[i].t != title[i]) {
                    // console.log(workbook.Strings[i].t, title[i]);
                    resolve({
                        title: `表头格式与模板栏位不对应，请使用标准模板处理\n第${i + 1}列应是${title[i]}`,
                    });
                }
            }
        }
    }

    resolve(jsono)
}


// function sheet2TableData(sheetJson) {
//     return sheetJson.Map((json, i) => {
//         Object.keys()
//     });
// }


function getTimeStr() {
    let date = new Date();
    return date.getHours() + ':' + date.getMinutes() + ":" + date.getSeconds() + "." + date.getMilliseconds();
}

export { excel2Json, excel2JsonCutSubHead }